import React, { useContext } from "react";
import { clsx } from "clsx";
import { useSafeIntl } from "@bloomberg/media.i18n";

import { GridTopContent } from "~components/GridLayout";
import BasicByline from "~components/Lede/BasicByline";
import SectionIdentifier from "~components/SectionIdentifier";
import {
    ArticleAbstract,
    ArticleDek,
    ArticleHeadline,
} from "~components/shared";
import { CurrentStoryContext } from "~utils/currentStoryContext";
import { getShouldShowAITakeaways } from "~utils/getShouldShowAITakeaways";
import isOpinion from "~utils/isOpinion";

import styles from "./BasicHeader.module.css";

export default function BasicHeader(): JSX.Element {
    const { story } = useContext(CurrentStoryContext);
    const isOpinionArticle = isOpinion(story);
    const { languageCode } = useSafeIntl();

    const { abstract, byline, headline, summaryHtml } = story;
    const shouldShowAbstract = !getShouldShowAITakeaways(story);
    const hasAbstract = Boolean(abstract?.length);

    return (
        <>
            <SectionIdentifier
                className={clsx(styles.sectionIdentifier, {
                    [styles.sectionIdentifierOpinion]: isOpinionArticle,
                })}
                story={story}
            />

            <GridTopContent>
                <header className={styles.header}>
                    <ArticleHeadline languageCode={languageCode}>
                        {headline}
                    </ArticleHeadline>

                    {shouldShowAbstract && (
                        <ArticleAbstract
                            abstract={abstract}
                            languageCode={languageCode}
                        />
                    )}

                    {!hasAbstract && (
                        <ArticleDek
                            dek={summaryHtml}
                            languageCode={languageCode}
                        />
                    )}
                </header>

                {/* Basic Article Byline and TTS are rendered in BasicContent component */}
                {isOpinionArticle && byline && (
                    <BasicByline story={story} className={styles.bylineBio} />
                )}
            </GridTopContent>
        </>
    );
}
